/* eslint-disable no-nested-ternary */
import React from 'react';
import {
  Box,
  Typography,
  ToggleButton,
  ToggleButtonGroup,
} from '@mui/material';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import PayPalLogo from './paypal-logo.png';

type PaymentHeaderProps = {
  hasSavedCards: boolean;
  paymentProvider: 'card' | 'paypal';
  isNewPaymentMethod: boolean;
  setFieldValue: (field: string, value: any) => void;
  hasSubscription: boolean;
  hasUpgrade: boolean;
  defaultPaymentMethodId?: string;
};

export default function PaymentHeader({
  hasSavedCards,
  paymentProvider,
  isNewPaymentMethod,
  setFieldValue,
  hasSubscription,
  hasUpgrade,
  defaultPaymentMethodId,
}: PaymentHeaderProps) {
  // Derive current selection from formik values
  const currentValue =
    paymentProvider === 'paypal'
      ? 'paypal'
      : isNewPaymentMethod
      ? 'new'
      : 'saved';

  const handleChange = (_: any, v: 'paypal' | 'new' | 'saved' | null) => {
    if (v === 'paypal') {
      setFieldValue('paymentProvider', 'paypal');
    } else {
      setFieldValue('paymentProvider', 'card');
      setFieldValue('isNewPaymentMethod', v === 'new');
      if (v === 'saved' && defaultPaymentMethodId) {
        setFieldValue('existingPaymentMethodToken', defaultPaymentMethodId);
      }
    }
  };

  return (
    <Box>
      <ToggleButtonGroup
        value={currentValue}
        exclusive
        onChange={handleChange}
        fullWidth
      >
        {hasSavedCards && (
          <ToggleButton
            value="saved"
            sx={{
              flex: 1,
              height: 50,
              border: '1px solid #ccc',
              '&.Mui-selected': {
                backgroundColor: '#e3f2fd',
                border: '2px solid #1976d2',
                color: '#1976d2',
              },
            }}
          >
            <CreditCardIcon sx={{ mr: 1 }} /> Existing Cards
          </ToggleButton>
        )}

        <ToggleButton
          value="new"
          sx={{
            flex: 1,
            height: 50,
            border: '1px solid #ccc',
            '&.Mui-selected': {
              backgroundColor: '#e3f2fd',
              border: '2px solid #1976d2',
              color: '#1976d2',
            },
          }}
        >
          <CreditCardIcon sx={{ mr: 1 }} /> New Card
        </ToggleButton>

        {!hasSubscription && (
          <ToggleButton
            value="paypal"
            sx={{
              flex: 1,
              height: 50,
              border: '1px solid #ccc',
              // '&.Mui-selected': {
              //   backgroundColor: '#f5f5f5',
              //   border: '2px solid #003087',
              //   color: '#003087',
              // },
              '&.Mui-selected': {
                backgroundColor: '#e3f2fd',
                border: '2px solid #1976d2', // stronger border when active
                color: '#1976d2',
                boxShadow: '0 0 4px rgba(25, 118, 210, 0.4)',
              },
            }}
          >
            <img
              src={PayPalLogo}
              alt="PayPal"
              style={{ height: 80, marginRight: 8 }}
            />
            {/* PayPal */}
          </ToggleButton>
        )}
      </ToggleButtonGroup>

      {/* Subtext */}
      <Box mt={2}>
        {paymentProvider === 'paypal' ? (
          <Typography variant="body2" color="text.secondary">
            You’ll be redirected to PayPal to complete your checkout.
          </Typography>
        ) : isNewPaymentMethod ? (
          <Typography variant="body2" color="text.secondary">
            Enter your new card details below.
          </Typography>
        ) : (
          <Typography variant="body2" color="text.secondary">
            Using your saved card.
          </Typography>
        )}
      </Box>
    </Box>
  );
}
